import {asyncType} from '../helpers';

export const serverKey = 'server';

export default {
   GET_SERVICE_PROPERTIES: asyncType(`${serverKey}/GET_SERVICE_PROPERTIES`),
   GET_PATH_SEPARATOR: asyncType(`${serverKey}/GET_PATH_SEPARATOR`),
   POST_SERVER_LOGINS: asyncType(`${serverKey}/POST_SERVER_LOGINS`),
   POST_FILE_OPERATIONS: asyncType(`${serverKey}/POST_FILE_OPERATIONS`),

   DOWNLOAD_CONNECTION_AUDIT_REPORT: asyncType(`${serverKey}/DOWNLOAD_CONNECTION_AUDIT_REPORT`),
} as const;
